import React from 'react';

import { strings } from 'common';

import MobileFlatTaskDialog from '../MobileFlatTaskDialog/MobileFlatTaskDialog';

type Props = {
  title: string;
  children: React.ReactElement;
  open: boolean;
  onClose: () => void;
};

const MobileEditFlatTask = ({ open, children, onClose }: Props) => {
  return (
    <MobileFlatTaskDialog
      open={open}
      onClose={onClose}
      title={strings.EDIT_TASK}
    >
      {children}
    </MobileFlatTaskDialog>
  );
};

export default MobileEditFlatTask;
